<template>
  <div class="search-flex">
    <div>
      <el-input 
        class="search_input" 
        clearable 
        placeholder="策略名称" 
        size="small" 
        v-model="searchParams.name">
      </el-input>
      <el-select 
        class="search_input" 
        v-model="searchParams.channelId" 
        filterable 
        :filter-method="dataFilter"
        clearable 
        size="small"
        placeholder="请选择渠道"
        @visible-change="handleVisibleChange">
        <el-option 
          v-for="item in channelShowOptions" 
          :key="item.id" 
          :label="getChannelLabel(item)"
          :value="item.id">
        </el-option>
      </el-select>
      <el-select 
        class="search_input" 
        clearable 
        placeholder="关联跳转" 
        size="small" 
        v-model="searchParams.showJumpId">
        <el-option 
          v-for="item in jumpOptions" 
          :key="item.id" 
          :label="`(${item.id})${item.name}`" 
          :value="item.id">
        </el-option>
      </el-select>
      <el-select 
        class="search_input" 
        clearable 
        placeholder="展示跳转按钮" 
        size="small" 
        v-model="searchParams.showJumpButton">
        <el-option label="展示" :value="1"></el-option>
        <el-option label="不展示" :value="0"></el-option>
      </el-select>
      <el-select 
        class="search_input" 
        clearable 
        placeholder="展示预留按钮" 
        size="small" 
        v-model="searchParams.showReservedButton">
        <el-option label="展示" :value="1"></el-option>
        <el-option label="不展示" :value="0"></el-option>
      </el-select>
      <el-select 
        class="search_input" 
        clearable 
        placeholder="状态" 
        size="small" 
        v-model="searchParams.status">
        <el-option label="生效" :value="1"></el-option>
        <el-option label="失效" :value="0"></el-option>
      </el-select>
    </div>
    <div class="search-btn">
      <!-- 搜索按钮 -->
      <el-button v-auth="'UPGRADE_POPUP_SEARCH'" type="primary" size="small" @click="search(1)">搜索</el-button>
      <!-- 新增按钮 -->
      <el-button v-auth="'UPGRADE_POPUP_ADD'" size="small" @click="add">新增</el-button>
      <!-- IM通知按钮 -->
      <el-button v-auth="'UPGRADE_POPUP_IM_NOTIFY'" type="warning" size="small" @click="openImNotify">IM 通知</el-button>
    </div>
    <EditDialog ref="editDialog" @reload="reload"></EditDialog>
    <ImNotifyDialog ref="imNotifyDialog" @reload="reload"></ImNotifyDialog>
  </div>
</template>

<script>
import { getUpgradePopupList, getAppJumpOptions } from "@/api/apps/upgradePopupManage";
import { appChannelList } from "@/api/member/index.js";
import Message from "@/components/Message";
import EditDialog from "./edit.vue";
import ImNotifyDialog from "./imNotifyDialog.vue";
import { debounce } from 'lodash';

export default {
  inject: ["searchParams", "list"],
  name: "UpgradePopupManageSearch",
  components: {
    EditDialog,
    ImNotifyDialog,
  },

  data() {
    return {
      jumpOptions: [],
      // 渠道选项
      channelOptions: [], // 所有渠道数据
      channelShowOptions: [], // 展示的渠道数据zhi接给我
    };
  },

  mounted() {
    this.getJumpOptions();
    // 初始化时获取渠道列表
    this.getChannelList();
  },

  methods: {
    /** 获取跳转选项 */
    async getJumpOptions() {
      try {
        const { data } = await getAppJumpOptions();
        this.jumpOptions = data.data || [];
      } catch (error) {
        console.error("获取跳转选项失败", error);
      }
    },

    /** 刷新列表 */
    reload() {
      console.log("search-reload");
      // 重置搜索条件并获取列表
      this.searchParams.current = 1;
      this.searchParams.name = "";
      this.searchParams.channelId = "";
      this.searchParams.showJumpId = "";
      this.searchParams.showJumpButton = "";
      this.searchParams.showReservedButton = "";
      this.searchParams.status = "";
      this.search();
    },
    /** 搜索 */
    async search(opt) {
      const params = { ...this.searchParams };
      this.searchParams.current = 1;
      
      console.log("搜索的参数", params);
      try {
        const { data } = await getUpgradePopupList(params);
        this.list.value = data.data.records;
        console.log("搜索的响应", data);
        this.searchParams.total = data.data.total;
        opt && Message.success("搜索成功");
      } catch (error) {
        console.error("搜索失败", error);
        Message.error("搜索失败");
      }
    },
    /** 新增的事件 */
    add() {
      this.$refs.editDialog.show('add');
    },
    /** 打开IM通知弹窗 */
    openImNotify() {
      this.$refs.imNotifyDialog.show();
    },

    // 获取渠道列表
    async getChannelList() {
      try {
        const { data } = await appChannelList();
        if (data.code === 200) {
          this.channelOptions = data.data || [];
          // 初始只显示前50条数据
          this.channelShowOptions = this.channelOptions.slice(0, 50);
        }
      } catch (error) {
        console.error('获取渠道列表失败:', error);
      }
    },
    // 处理下拉框显示/隐藏
    handleVisibleChange(visible) {
      if (visible) {
        // 显示时重置为前50条数据减少dom渲染
        this.channelShowOptions = this.channelOptions.slice(0, 50);
      } else {
        this.channelShowOptions = [];
      }
    },
    // 过滤渠道数据
    dataFilter: debounce(function(val) {
      if (val) {
        // 在所有数据中搜索
        this.channelShowOptions = this.channelOptions.filter(item => 
          this.getChannelLabel(item).toLowerCase().indexOf(val.trim().toLowerCase()) !== -1
        );
      } else {
        // 无搜索词时显示前50条
        this.channelShowOptions = this.channelOptions.slice(0, 50);
      }
    }, 300),
    // 获取渠道显示文本
    getChannelLabel(item) {
      return `[${item.id}] ${item.name}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.search-flex {
  display: flex;
  align-items: center;
}

.search-btn {
  flex: 1;
  display: flex;
  justify-content: flex-end;
  padding-top: 10px;
}

.search_input {
  width: 160px !important;
  margin: 10px 20px 0 0;
}
</style> 